import { useEffect, useMemo } from 'react';
import { ColumnCellEditorActions, ICellEditor } from '@aleph/shared-components';
import { AdMedia } from 'wb-reddit/app/routes/superGrid/columnDefinitions/ad';
import { CreativeType } from 'wb-reddit/graphql/generated';

const RedditMediaCellEditor = (params: ICellEditor<AdMedia> & { forceType?: CreativeType }) => {
	const initialValue = useMemo(() => params.value, []);

	const {
		data, setValue, editorContext, setEditorContext,
	} = params;

	useEffect(() => {
		setEditorContext({
			...editorContext,
			creativeType: params?.forceType ?? data.creativeType,
		});
	}, [data.creativeType]);

	const onKeyDown = (e: React.KeyboardEvent) => {
		if (e.key === 'Enter') {
			params.stopEditing();
		}

		if (e.key === 'Escape') {
			setValue(initialValue);

			setTimeout(() => params.stopEditing());
		}
	};

	const onCancel = () => {
		setValue(initialValue);
		params.api.stopEditing(true);
	};

	const onConfirm = () => {
		setValue(params.value);
		params.stopEditing();
	};

	if (!params.value?.mediaUrl) {
		return (
			<div
				className="flex flex-row gap-[8px] items-center justify-between h-full w-full"
				onKeyDown={onKeyDown}
			>
				<div className="flex items-center h-full px-[8px] text-gray-700">
					Select media...
				</div>
				<ColumnCellEditorActions
					onCancel={onCancel}
					onConfirm={onConfirm}
					confirmVisible={!!params.value?.mediaUrl}
					confirmText={'CONFIRM'}
				/>
			</div>
		);
	}

	return (
		<div
			className="flex flex-row gap-[8px] items-center justify-between h-full w-full"
			onKeyDown={onKeyDown}
		>
			<img
				alt="media"
				className="h-full aspect-square object-cover"
				src={params.value?.mediaThumbnail ?? ''}
			/>

			<div className='flex flex-1 max-w-[70%] overflow-hidden overflow-ellipsis'>
				<span className='overflow-hidden overflow-ellipsis'>
					{params.value?.mediaUrl}
				</span>
			</div>

			<ColumnCellEditorActions
				onCancel={onCancel}
				onConfirm={onConfirm}
				confirmVisible={!!params.value?.mediaUrl}
				confirmText={'CONFIRM'}
			/>
		</div>
	);
};

export default RedditMediaCellEditor;
